import { createContext, useEffect, useReducer, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import axios from '../utils/axios';

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIALIZE':
      return { ...state, isInitialized: true, isAuthenticated: action.payload.isAuthenticated, user: action.payload.user };
    case 'LOGIN':
      return { ...state, isAuthenticated: true, user: action.payload.user };
    case 'LOGOUT':
      return { ...state, isAuthenticated: false, user: null };
    default:
      return state;
  }
};

const AuthContext = createContext(null);

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const initialize = useCallback(async () => {
    // Impersonate orqali kirish
    const params = new URLSearchParams(window.location.search);
    if (params.get('impersonate') === 'true' && params.get('accessToken')) {
      const impersonateAccess = params.get('accessToken');
      const impersonateRefresh = params.get('refreshToken');
      localStorage.setItem('accessToken', impersonateAccess);
      if (impersonateRefresh) localStorage.setItem('refreshToken', impersonateRefresh);
      // URL dan tokenlarni tozalash
      window.history.replaceState({}, '', window.location.pathname);
    }

    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      try {
        // Token bilan user ma'lumotini tekshirish
        const response = await axios.get('/auth/me');
        dispatch({ type: 'INITIALIZE', payload: { isAuthenticated: true, user: response.data } });
      } catch {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        dispatch({ type: 'INITIALIZE', payload: { isAuthenticated: false, user: null } });
      }
    } else {
      dispatch({ type: 'INITIALIZE', payload: { isAuthenticated: false, user: null } });
    }
  }, []);

  useEffect(() => {
    initialize();
  }, [initialize]);

  const login = useCallback(async (phone, password) => {
    const response = await axios.post('/auth/login', { phone, password });
    const { accessToken, refreshToken } = response.data;

    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);

    // Token decode qilib user ma'lumot olish
    const payload = JSON.parse(atob(accessToken.split('.')[1]));
    const user = { id: payload.sub, role: payload.role };

    dispatch({ type: 'LOGIN', payload: { user } });
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    dispatch({ type: 'LOGOUT' });
  }, []);

  const value = useMemo(
    () => ({ ...state, login, logout }),
    [state, login, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export { AuthContext, AuthProvider };
